<template>
  <q-dialog v-model="isDispDialog" persistent class="privacy-policy-area">
    <q-card style="width: 80%; max-width: 900px">
      <q-card-section class="privacy-policy-title q-pb-none">プライバシーポリシー </q-card-section>
      <q-separator inset spaced />

      <q-scroll-area
        style="height: 500px; width: 90%; margin: 0 auto; padding-right: 15px"
        visible
        @scroll="setEnableButton"
      >
        <div class="privacy-policy-item">1.個人情報とは</div>
        <p>
          個人情報とは、個人情報の保護に関する法律に規定される生存する個人に関する情報、ならびに特定の個人情報と容易に照合することができ、それにより特定の個人を識別することができる情報をいいます。
        </p>
        <div class="privacy-policy-item">2.個人情報の取得について</div>
        <p>
          弊社は、あらかじめご本人へ収集目的を明確にした上で適正に個人情報を取得し、偽りその他不正の手段により取得することはありません。
        </p>
        <div class="privacy-policy-item">3.クッキー・IPアドレス情報</div>
        <p>
          クッキー及びIPアドレス情報については、それら単独では特定の個人を識別することができないため、個人情報とは考えておりません。ただしこれら情報と個人情報が一体となって使用される場合にはこれら情報も個人情報とみなします。また、クッキー情報については、ブラウザの設定で拒否することが可能です。クッキーを拒否するとサービスが受けられない場合は、その旨の公表に努めます。
        </p>

        <div class="privacy-policy-item">4.個人情報の利用について</div>
        <p>
          弊社は、あらかじめご本人の同意を得ず、利用目的の達成に必要な範囲を超えて個人情報を取扱うことはありません。<br />
          ただし、以下の場合はこの限りではありません。
        </p>
        <ol>
          <li>法令に基づく場合</li>
          <li>
            人の生命、身体または財産の保護のために必要がある場合であって、ご本人の同意を得ることが困難であるとき<br />
          </li>
          <li>
            公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、ご本人の同意を得ることが困難であるとき<br />
          </li>
          <li>
            国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、ご本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき
          </li>
        </ol>
        <div class="privacy-policy-item">5.個人情報の管理と保護、セキュリティについて</div>
        <p>
          弊社は個人情報へのアクセス管理、外部からの不正なアクセスの防止、その他の個人情報の安全管理のために必要かつ適切な処置を厳重に行うこととし、個人情報の漏洩、紛失、破壊、改ざん及び不正アクセスなどの予防・是正に努めます。
        </p>
        <div class="privacy-policy-item">6.個人情報の開示について</div>
        <p>
          弊社は、お客様本人またはその代理人から、当該個人情報の開示についての請求があったときは、次の各号の場合を除き、適切な期間でご回答いたします。<br />
        </p>
        <ol>
          <li>ご本人または第三者の生命、身体、財産その他の権利利益を害するおそれがある場合</li>
          <li>弊社の業務の適正な実施に著しい支障を及ぼすおそれがある場合</li>
          <li>法令に違反することとなる場合</li>
        </ol>
        <div class="privacy-policy-item">7.個人情報の訂正等について</div>
        <p>
          弊社は、ご本人またはその代理人から当該個人情報が真実でないという理由によって、内容の訂正、追加または削除(以下「訂正等」といいます)の申出があった場合、他の法令の規定により特別の手続きが定められている場合を除き、合理的な期間で調査を行い、その結果に基き利用目的の達成に必要な範囲内において当該個人情報の内容の訂正等を行い、その旨をご本人に通知します。
        </p>
        <div class="privacy-policy-item">8.個人情報のお問合せ</div>
        <p>弊社のプライバシーポリシーに関するお問合せは、お問合せフォームからお願いいたします。</p>
      </q-scroll-area>
      <q-card-actions align="center" class="q-mt-sm q-mb-md">
        <q-btn
          color="primary"
          label="OK"
          :disable="isBottomScroll"
          style="width: 220px"
          @click="emit('closeDialog', true)"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
<script setup lang="ts">
import { ref, computed } from 'vue';

interface Props {
  // ダイアログ表示フラグ
  isDispDialog: boolean;
}
const props = defineProps<Props>();
const emit = defineEmits(['closeDialog']);

// ダイアログ表示フラグ
const isDispDialog = ref(computed(() => props.isDispDialog));

// スクロールフラグ
const isBottomScroll = ref(true);

/**
 * OKボタンを活性に設定
 * @param verticalPercentage スクロール位置
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const setEnableButton = ({ verticalPercentage }: any) => {
  // スクロール位置が最下部の場合
  if (verticalPercentage >= 0.8) {
    isBottomScroll.value = false;
  }
};
</script>
<style scoped>
.privacy-policy-title {
  color: var(--q-negative);
  font-size: 1.1rem;
  font-weight: 600;
  text-align: center;
}
.privacy-policy-item {
  font-size: 1rem;
  font-weight: 600;
  color: var(--q-primary);
}
.privacy-policy-area.q-dialog .q-btn.disabled {
  background-color: var(--q-disabledColor) !important;
}
</style>
